import { RiAddLine } from "@remixicon/react";
import React from "react";

export const sharedProps = {
  leftIcon: <RiAddLine size={16} />,
  pl: 1,
  placeholder: "Add",
  rightIcon: undefined,
  variant: "ghost",
};

export type SelectorProps = {
  name?: string;
  value?: string[];
  isReadOnly?: boolean;
  onChange?: (value: string[]) => void;
  onBlur?: () => void;
};
